export default __webpack_public_path__ + "static/media/pramanit.19939733.png";